<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { groups } from 'src/stores/lists/groups';
	import { _init_group_actions } from '../../../../../../helpers/init_group_actions';
	import { _deepClone, _deepCopyArr } from '../../../../../../../../helpers/utilities';
	import ActionsOnRollers from './Components/ActionsOnRollersV2.svelte';
	import ActionsOnRelays from './Components/ActionsOnRelaysV2.svelte';
	import { DO_WIZARD_STEPS_INDEXES } from '../../helpers/do-wizard-helpers';

	export let sceneData: any;

	const validateWizardStepChangeState = () => {
		sceneData.isValid = true;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.GROUP_CHANGE_STATE;
	};
</script>

{#if $groups[sceneData.selectedGroup.id]?.type === 'relay'}
	<ActionsOnRelays
		actions={sceneData.groupAction.components}
		active_actions={sceneData.groupAction.actions}
		on:change_active={(e) => {
			validateWizardStepChangeState();
			sceneData.groupAction.actions = _deepCopyArr(e.detail.new_active);
		}}
	/>
{:else if $groups[sceneData.selectedGroup.id]?.type === 'roller'}
	<ActionsOnRollers
		actions={sceneData.groupAction.components}
		active_actions={sceneData.groupAction.actions}
		on:change_active={(e) => {
			validateWizardStepChangeState();
			sceneData.groupAction.actions = _deepCopyArr(e.detail.new_active);
		}}
	/>
{:else if $groups[sceneData.selectedGroup.id]?.type === 'light'}
	<ActionsOnRelays
		actions={sceneData.groupAction.components}
		active_actions={sceneData.groupAction.actions}
		on:change_active={(e) => {
			validateWizardStepChangeState();
			sceneData.groupAction.actions = _deepCopyArr(e.detail.new_active);
		}}
	/>
{:else if $groups[sceneData.selectedGroup.id]?.type === 'thermostat'}
	<Text>Actions for trv-s</Text>
{/if}
